module.exports = __webpack_public_path__ + "img/playbutton29.1c822255.png";